import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0791776f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-list" }

import { ref } from 'vue'
import { queryTenantOrder } from '@/api'
import { useRoute } from 'vue-router'
import { PAGE_SIZES, CODE_ENUM } from '@/common'
import moment from 'moment'


export default /*#__PURE__*/_defineComponent({
  __name: 'order-list',
  setup(__props) {

const $route = useRoute()

const topOrgId = $route.query.orgId

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const tableLoading = ref(false)
const tableData: any = ref([])
const fetchList = async () => {
  tableLoading.value = true
  const res: any = await queryTenantOrder({
    ...pageParams.value,
    topOrgId,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

fetchList()

const col = [
  {
    prop: 'orderId',
    label: '订单号',
  },
  {
    prop: 'createOrderTime',
    label: '下单时间',
    formatter: ({ createOrderTime }: any) => {
      return moment(createOrderTime).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  {
    prop: 'packageName',
    label: '下单产品',
  },
  {
    prop: 'price',
    label: '订单总价',
  },
  {
    prop: 'disCountPrice',
    label: '优惠金额',
  },
]

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      class: "ws_common_table ws_mt20",
      data: tableData.value
    }, {
      empty: _withCtx(() => [
        _createVNode(_component_el_empty, { description: "暂无数据" })
      ]),
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(col, (item, index) => {
          return _createVNode(_component_el_table_column, _mergeProps({ key: index }, {
          ...item,
        }, { "show-overflow-tooltip": "" }), null, 16)
        }), 64))
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, tableLoading.value]
    ]),
    _createVNode(_component_el_pagination, {
      class: "ws_mt50",
      "current-page": pageParams.value.curPage,
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((pageParams.value.curPage) = $event)),
      "page-size": pageParams.value.pageSize,
      "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageParams.value.pageSize) = $event)),
      "page-sizes": _unref(PAGE_SIZES),
      layout: "->, total, sizes, prev, pager, next, jumper ",
      total: total.value,
      onSizeChange: handleSizeChange,
      onCurrentChange: handleCurrentChange
    }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
  ]))
}
}

})